export default "__VITE_ASSET__3f82dd10__"